<template>
  <div class="greenEnergyExpert_box">
    <div class="head_nav">
      <!-- <div class="title">酒店降本增效的</div>
      <div class="slogan">绿色引擎</div> -->
    </div>
    <div class="content_nav">
      <div class="product_box">
        <div class="function_box">
          <div class="label">新型储能流程</div>
          <div class="en_label">New energy storage process</div>
        </div>
        <div class="new_list">
          <div class="li_box" v-for="(item,index) in newList" :key="item.label">
            <img :src="item.icon" alt="" class="new_icon">
            <div class="new_num">{{item.num}}</div>
            <div class="new_text">{{item.label}}</div>
            <div v-if="index+1 != newList.length" class="heng"></div>
            <div v-if="index+1 != newList.length" class="jian"></div>
          </div>
        </div>
      </div>
      <div class="module_box">
        <div class="function_box">
          <div class="label">新型储能特点</div>
          <div class="en_label">Characteristics of New Energy Storage</div>
        </div>
        <div class="new_list">
          <div class="li_box" v-for="(item,index) in storageList" :key="item.label">
            <img :src="item.icon" alt="" class="new_icon">
            <div class="new_l">{{item.label}}</div>
            <div class="new_s">{{item.description}}</div>
            <div class="heng"></div>
            <div class="heng1"></div>
          </div>
        </div>
      </div>
      <div class="core_box">
        <div class="function_box">
          <div class="label">项目案例</div>
          <div class="en_label">Project case</div>
        </div>
        <div class="button">
          <el-icon class="icon" @click="goLeft()"><ArrowLeftBold /></el-icon>
          <el-icon class="icon" @click="goRight()"><ArrowRightBold /></el-icon>
        </div>
        <div class="menu_box">
          <div class="item" v-for="item in hotelListPage[hotelIndex]" :key="item.label">
            <img :src="(item.icon)" alt="">
            <div class="label_text">
              {{ item.label }}
            </div>
            <div class="label_info">
              <div class="info_box">
                <div class="info_num">
                  <span>{{item.num1}}</span>
                  <span class="num_unit">{{item.unit1}}</span>
                </div>
                <div class="info_name">装机功率</div>
              </div>
              <div class="info_box">
                <div class="info_num">
                  <span>{{item.num2}}</span>
                  <span class="num_unit">{{item.unit2}}</span>
                </div>
                <div class="info_name">装机容量</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { useStore } from "vuex";
import { computed, ref, getCurrentInstance   } from "vue";
import { ArrowLeftBold, ArrowRightBold } from '@element-plus/icons'
export default {
  name: "greenEnergyExpert",
  components: {
    ArrowLeftBold, ArrowRightBold
  },
  setup() {
    const dom = getCurrentInstance()
    const state = computed(() => useStore().state.client);
    const newList = ref([
      {
        num: '01',
        label: '容量规划',
        icon: `https://sys.huwei.xin:7443/huwei-website/imageNew/energyStorage/01.png`
      },
      {
        num: '02',
        label: '备案审批',
        icon: `https://sys.huwei.xin:7443/huwei-website/imageNew/energyStorage/02.png`
      },
      {
        num: '03',
        label: '设计施工',
        icon: `https://sys.huwei.xin:7443/huwei-website/imageNew/energyStorage/03.png`
      },
      {
        num: '04',
        label: '并网验收',
        icon: `https://sys.huwei.xin:7443/huwei-website/imageNew/energyStorage/04.png`
      },
      {
        num: '05',
        label: '持续运维',
        icon: `https://sys.huwei.xin:7443/huwei-website/imageNew/energyStorage/05.png`
      },
    ])
    const storageList = ref([
      {
        icon: `https://sys.huwei.xin:7443/huwei-website/imageNew/energyStorage/n1.png`,
        label: '精准分析',
        description: '深度洞察酒店用电特性，数据驱动决策'
      },
      {
        icon: `https://sys.huwei.xin:7443/huwei-website/imageNew/energyStorage/n2.png`,
        label: '经验赋能',
        description: '依托众多成功案例，提供成熟可靠的方案参考'
      },
      {
        icon: `https://sys.huwei.xin:7443/huwei-website/imageNew/energyStorage/n3.png`,
        label: '优化配置',
        description: '量身定制储能方案，实现投资效益最大化'
      },
      {
        icon: `https://sys.huwei.xin:7443/huwei-website/imageNew/energyStorage/n4.png`,
        label: '全程托管',
        description: '专业团队负责备案并网，客户省心省力'
      },
      {
        icon: `https://sys.huwei.xin:7443/huwei-website/imageNew/energyStorage/n5.png`,
        label: '快速落地',
        description: '模块化施工，项目投资快人一步'
      },
      {
        icon: `https://sys.huwei.xin:7443/huwei-website/imageNew/energyStorage/n6.png`,
        label: '稳定可靠',
        description: '提供持续专业的运维服务，保障电站长效运行'
      },
    ])
    const hardwareList = ref([
      {
        device: '电压互感器',
        label: '漏电流'
      },
      {
        device: '电流互感器',
        label: '房间电流'
      },
      {
        device: '烟雾传感器',
        label: '进线电压'
      },
      {
        device: '漏电流传感器',
        label: '漏电流传感器'
      },
      {
        device: '温湿度传感器',
        label: '配电箱温度'
      },
    ])
    const hotelIndex = ref(0)
    const goRight = () => {
      if(hotelIndex.value == hotelListPage.value.length - 1) {
        hotelIndex.value = 0;
      }else {
        hotelIndex.value ++;
      }
    }
    const goLeft = () => {
      if(hotelIndex.value == 0) {
        hotelIndex.value = hotelListPage.value.length - 1;
      }else {
        hotelIndex.value --;
      }
    }
    const hotelListPage = ref([
      [{
        icon: `https://sys.huwei.xin:7443/huwei-website/imageNew/energyStorage/anli_01.png`,
        label: '海南儋州市某海岛酒店储能项目',
        num1: '2.4',
        unit1: 'MW',
        num2: '5.16',
        unit2: 'MWh',
      },
      {
        icon: `https://sys.huwei.xin:7443/huwei-website/imageNew/energyStorage/anli_02.png`,
        label: '海南三亚某知名度假酒店储能项目',
        num1: '630',
        unit1: 'kW',
        num2: '1290',
        unit2: 'kWh',
      },
      {
        icon: `https://sys.huwei.xin:7443/huwei-website/imageNew/energyStorage/anli_03.png`,
        label: '舟山普陀某高星酒店储能项目',
        num1: '630',
        unit1: 'kW',
        num2: '1290',
        unit2: 'kWh',
      },
      {
        icon: `https://sys.huwei.xin:7443/huwei-website/imageNew/energyStorage/anli_04.png`,
        label: '千岛湖某高端度假酒店储能项目',
        num1: '630',
        unit1: 'kW',
        num2: '1290',
        unit2: 'kWh',
      },
      {
        icon: `https://sys.huwei.xin:7443/huwei-website/imageNew/energyStorage/anli_05.png`,
        label: '杭州天目某高端温泉酒店储能项目',
        num1: '525',
        unit1: 'kW',
        num2: '1075',
        unit2: 'kWh',
      },
      {
        icon: `https://sys.huwei.xin:7443/huwei-website/imageNew/energyStorage/anli_06.png`,
        label: '浙江杭州某商务中心储能项目',
        num1: '800',
        unit1: 'kW',
        num2: '1600',
        unit2: 'kWh',
      },],
      [{
        icon: `https://sys.huwei.xin:7443/huwei-website/imageNew/energyStorage/anli_07.png`,
        label: '杭州千岛湖某精品酒店储能项目',
        num1: '210',
        unit1: 'kW',
        num2: '430',
        unit2: 'kWh',
      },
      {
        icon: `https://sys.huwei.xin:7443/huwei-website/imageNew/energyStorage/anli_08.png`,
        label: '杭州青山湖某高端国际酒店储能项目',
        num1: '1260',
        unit1: 'kW',
        num2: '2580',
        unit2: 'kWh',
      },
      {
        icon: `https://sys.huwei.xin:7443/huwei-website/imageNew/energyStorage/anli_09.png`,
        label: '浙江西湖某国宾接待酒店储能项目',
        num1: '840',
        unit1: 'kW',
        num2: '1720',
        unit2: 'kWh',
      },
      {
        icon: `https://sys.huwei.xin:7443/huwei-website/imageNew/energyStorage/anli_10.png`,
        label: '杭州滨江某高星酒店储能项目',
        num1: '812',
        unit1: 'kW',
        num2: '1631',
        unit2: 'kWh',
      },
      {
        icon: `https://sys.huwei.xin:7443/huwei-website/imageNew/energyStorage/anli_11.png`,
        label: '三亚某豪华型度假酒店储能项目',
        num1: '420',
        unit1: 'kW',
        num2: '860',
        unit2: 'kWh',
      },
      {
        icon: `https://sys.huwei.xin:7443/huwei-website/imageNew/energyStorage/anli_12.png`,
        label: '杭州建德某精品度假酒店储能项目',
        num1: '210',
        unit1: 'kW',
        num2: '430',
        unit2: 'kWh',
      },],
      [{
        icon: `https://sys.huwei.xin:7443/huwei-website/imageNew/energyStorage/anli_13.png`,
        label: '杭州云村某星文化主题酒店储能项目',
        num1: '210',
        unit1: 'kW',
        num2: '430',
        unit2: 'kWh',
      }],
    ])
    const menuList = ref([
      {
        icon: `https://sys.huwei.xin:7443/huwei-website/imageNew/energyStorage/anli_01.png`,
        label: '海南儋州市某海岛酒店储能项目',
        num1: '2.4',
        unit1: 'MW',
        num2: '5.16',
        unit2: 'MWh',
      },
      {
        icon: `https://sys.huwei.xin:7443/huwei-website/imageNew/energyStorage/anli_02.png`,
        label: '海南三亚某知名度假酒店储能项目',
        num1: '630',
        unit1: 'kW',
        num2: '1290',
        unit2: 'kWh',
      },
      {
        icon: `https://sys.huwei.xin:7443/huwei-website/imageNew/energyStorage/anli_03.png`,
        label: '舟山普陀某高星酒店储能项目',
        num1: '630',
        unit1: 'kW',
        num2: '1290',
        unit2: 'kWh',
      },
      {
        icon: `https://sys.huwei.xin:7443/huwei-website/imageNew/energyStorage/anli_04.png`,
        label: '千岛湖某高端度假酒店储能项目',
        num1: '630',
        unit1: 'kW',
        num2: '1290',
        unit2: 'kWh',
      },
      {
        icon: `https://sys.huwei.xin:7443/huwei-website/imageNew/energyStorage/anli_05.png`,
        label: '杭州天目某高端温泉酒店储能项目',
        num1: '525',
        unit1: 'kW',
        num2: '1075',
        unit2: 'kWh',
      },
      {
        icon: `https://sys.huwei.xin:7443/huwei-website/imageNew/energyStorage/anli_06.png`,
        label: '浙江杭州某商务中心储能项目',
        num1: '800',
        unit1: 'kW',
        num2: '1600',
        unit2: 'kWh',
      },
    ])
    const applicationList = ref([
      {
        name: '单体酒店',
        bg: 'monomer_hotel_img.png',
        menuList: [
          {
            label: '排房方案优化'
          },
          {
            label: '非正常用电告警'
          },
          {
            label: '用电隐患监测'
          },
          {
            label: '同类酒店能耗对比'
          },
        ]
      },
      {
        name: '连锁酒店',
        bg: 'chain_hotel_img.png',
        menuList: [
          {
            label: '排房方案优化'
          },
          {
            label: '非正常用电告警'
          },
          {
            label: '用电隐患监测'
          },
          {
            label: '同级别、同系列酒店能耗对比'
          },
          {
            label: '酒店内部能耗名单和价格辅助策略'
          },
          {
            label: '酒店内部线路和电器残值分析和更换提醒'
          },
        ]
      },
      {
        name: '订房平台',
        bg: 'reservation_platform_img.png',
        menuList: [
          {
            label: '能耗名单和客房报价辅助策略'
          },
          {
            label: '住客的行为分析'
          },
          {
            label: '精准广告推送'
          },
        ]
      },
    ])
    return {
      dom,
      state,
      newList,
      storageList,
      hardwareList,
      menuList,
      goRight,
      goLeft,
      hotelIndex,
      hotelListPage,
      applicationList
    }
  }
}
</script>
<style lang="scss" scoped>
.greenEnergyExpert_box {
  width: 100%;
  .head_nav {
    background: url('https://sys.huwei.xin:7443/huwei-website/imageNew/energyStorage/banner.png') no-repeat 100% 100%;
    background-size: cover;
    width: 100%;
    height: 400px;
    display: flex;
    justify-content: center;
    flex-direction: column;
    color: #ffffff;
    box-sizing: border-box;
    padding-left: 200px;
    font-weight: 800;
    .title {
      font-size: 50px;
      color: #132F59;
      line-height: 84px;
    }
    .slogan {
      font-size: 50px;
      color: #1667FF;
      line-height: 84px;
    }
  }
  .content_nav {
    position: relative;
    .product_box {
      background: #FFFFFF;
      padding: 100px 200px;
      box-sizing: border-box;
      .function_box {
        display: flex;
        align-items: baseline;
        margin-bottom: 100px;
        .label {
          font-size: 40px;
          font-weight: 800;
          color: #132F59;
          line-height: 55px;
          padding-left: 8px;
        }
        .en_label {
          font-size: 22px;
          color: #656973;
          line-height: 22px;
          padding: 8px 12px;
          font-weight: 200;
        }
      }
      .new_list{
        display: flex;
        justify-content: space-between;
        padding: 0 20px;
        .li_box{
          display: flex;
          flex-direction: column;
          align-items: center;
          position: relative;
          .heng{
            width: 110px;
            height: 2px;
            background: #DBE2F2;
            position: absolute;
            top: 79px;
            right: -140px;
          }
          .jian{
            width: 0;
            height: 0;
            border-top: 7px solid transparent;
            border-bottom: 7px solid transparent;
            border-left: 7px solid #9BBFF3;
            position: absolute;
            top: 74px;
            right: -88px;
          }
          .new_icon{
            width: 160px;
            height: 160px;
          }
          .new_num{
            background: url(https://sys.huwei.xin:7443/huwei-website/imageNew/energyStorage/num_bg.png) 0 0 no-repeat;
            background-size: 100%;
            width: 60px;
            height: 60px;
            line-height: 60px;
            text-align: center;
            font-size: 28px;
            color: #FFFFFF;
            margin: 10px;
          }
          .new_text{
            font-size: 28px;
            color: #132F59;
            line-height: 38px;
            text-align: center;
          }
        }
      }
    }
    .module_box {
      background: linear-gradient( 180deg, #F4F7FF 0%, #FFFFFF 100%);
      padding: 100px 200px;
      box-sizing: border-box;
      .function_box {
        display: flex;
        align-items: baseline;
        margin-bottom: 100px;
        .label {
          font-size: 40px;
          font-weight: 800;
          color: #132F59;
          line-height: 55px;
          padding-left: 8px;
        }
        .en_label {
          font-size: 22px;
          color: #656973;
          line-height: 22px;
          padding: 8px 12px;
          font-weight: 200;
        }
      }
      .new_list{
        display: flex;
        justify-content: space-between;
        
        .li_box{
          padding: 53px 40px;
          width: 232px;
          height: 383px;
          background: #fff;
          display: flex;
          flex-direction: column;
          position: relative;
          box-sizing: border-box;
          .new_icon{
            width: 80px;
            height: 80px;
          }
          .new_l{
            font-size: 20px;
            color: #132F59;
            line-height: 28px;
            margin-top: 42px;
            margin-bottom: 19px;
            font-weight: bold;
          }
          .new_s{
            font-size: 18px;
            color: #656973;
            line-height: 30px;
          }
          .heng{
            position: absolute;
            width: 80%;
            height: 3px;
            background: #1667FF;
            bottom: 0;
            left: 0;
          }
          .heng1{
            position: absolute;
            width: 20%;
            height: 3px;
            background: #00B386;
            bottom: 0;
            right: 0;
          }
        }
      }
    }
    .hardware_box {
      background: url(https://sys.huwei.xin:7443/huwei-website/imageNew/greenEnergyExpert/zz_bg.png) 0 0 no-repeat;
      background-size: 100% 100%;
      height: 932px;
      padding: 100px 200px;
      box-sizing: border-box;
      .function_box {
        display: flex;
        align-items: baseline;
        margin-bottom: 100px;
        .label {
          font-size: 40px;
          font-weight: 800;
          color: #fff;
          line-height: 55px;
          padding-left: 8px;
        }
        .en_label {
          font-size: 22px;
          color: #fff;
          line-height: 22px;
          padding: 8px 12px;
          font-weight: 200;
        }
      }
      .hardware_content {
        display: flex;
        padding: 30px 0;
        width: 100%;
        box-sizing: border-box;
        .right_img {
          img {
            width: 801px;
            height: 484px;
          }
        }
        .content_box {
          flex: 1;
          display: flex;
          flex-direction: column;
          .title_box {
            display: grid;
            grid-template-columns: 112px 112px;
            padding: 0 0 40px 62px;
            grid-gap: 200px;
            div {
              font-size: 24px;
              color: #fff;
              line-height: 33px;
              font-weight: bold;
            }
          }
          .item_box {
            display: grid;
            grid-template-columns: 47% 50%;
            padding-bottom: 16px;
            .item {
              display: grid;
              grid-template-columns: 26px auto;
              grid-gap: 16px;
              justify-content: center;
              align-items: center;
              width: 229px;
              height: 66px;
              box-sizing: border-box;
              border: 1px solid #FFFFFF;
              .index {
                font-size: 22px;
                color: #fff;
                font-weight: 600;
                line-height: 30px;
              }
              .item_text {
                font-size: 18px;
                font-weight: 100;
                color: #fff;
                line-height: 25px;
              }
            }
          }
        }
      }
    }
    .support_nav {
      height: 666px;
      background: linear-gradient( 180deg, #FFFFFF 0%, #F4F7FF 100%);
      padding: 100px 200px;
      box-sizing: border-box;
      .text_bg {
        position: absolute;
        width: 883px;
        font-size: 200px;
        font-weight: bold;
        color: #F2F2F2;
        line-height: 180px;
        padding: 36px 20px;
      }
      .function_box {
        display: flex;
        align-items: baseline;
        margin-bottom: 100px;
        .label {
          font-size: 40px;
          font-weight: 800;
          color: #132F59;
          line-height: 55px;
          padding-left: 8px;
        }
        .en_label {
          font-size: 22px;
          color: #656973;
          line-height: 22px;
          padding: 8px 12px;
          font-weight: 200;
        }
      }
      .step_box {
        position: relative;
        width: 100%;
        display: flex;
        box-sizing: border-box;
        justify-content: space-between;
        .item {
          width: 433px;
          height: 313px;
          background: #FFFFFF;
          border-radius: 4px;
          .index_box {
            width: 120px;
            height: 120px;
            position: relative;
            margin: 9px 32px;
            display: flex;
            align-items: center;
            .index_bg {
              position: absolute;
              font-size: 100px;
              color: #F6F9FF;
              line-height: 120px;
              font-weight: 800;
            }
            .label {
              position: relative;
              font-size: 30px;
              color: #132F59;
              line-height: 23px;
              font-weight: bold;
              padding-top: 60px;
            }
          }
          .decription {
            font-size: 18px;
            font-weight: 400;
            color: #656973;
            line-height: 25px;
            padding: 30px 32px;
          }
        }
        .icon {
          display: flex;
          justify-content: center;
          align-items: center;
          color: #1667FF;
        }
      }
    }
    .desc_box{
      background: url(https://sys.huwei.xin:7443/huwei-website/imageNew/greenEnergyExpert/yx_bg.png) 0 0 no-repeat;
      background-size: 100% 100%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      width: 100%;
      height: 185px;
      padding: 0 200px;
      .title{
        font-size: 30px;
        color: #132F59;
        line-height: 42px;
        margin-bottom: 27px;
        font-weight: bold;
      }
      .desc{
        font-size: 18px;
        color: #656973;
        line-height: 22px;
      }
    }
    .core_box {
      background: linear-gradient( 180deg, #F4F7FF 0%, #FFFFFF 100%);
      padding: 100px 200px;
      box-sizing: border-box;
      position: relative;
      .function_box {
        display: flex;
        align-items: baseline;
        margin-bottom: 100px;
        .label {
          font-size: 40px;
          font-weight: 800;
          color: #132F59;
          line-height: 55px;
          padding-left: 8px;
        }
        .en_label {
          font-size: 22px;
          color: #656973;
          line-height: 22px;
          padding: 8px 12px;
          font-weight: 200;
        }
      }
      .button {
        position: absolute;
        right: 200px;
        top: 110px;
        width: 100%;
        margin-bottom: 40px;
        display: inline-flex;
        justify-content: end;
        grid-gap: 50px;
        .icon {
          width: 40px;
          height: 40px;
          cursor: pointer;
          box-sizing: border-box;
          display: flex;
          align-items: center;
          justify-content: center;
          color: #3D3F55;
          font-size: 15px;
          border: 1px solid #3D3F55;
        }
        .icon:hover{
          background: #1667FF;
          color: #fff;
          border: 1px solid #fff;
        }
      }
      .menu_box {
        width: 100%;
        display: grid;
        grid-template-columns: repeat(3,1fr);
        grid-gap: 61px 30px;
        box-sizing: border-box;
        
        .item {
          width: 485px;
          height: 455px;
          background: #FFFFFF;
          padding: 270px 0 0 30px;
          box-sizing: border-box;
          // text-align: center;
          position: relative;
          // align-items: center;
          img {
            width: 485px;
            height: 240px;
            position: absolute;
            object-fit: cover;
            top: 0;
            left: 0;
          }
          .label_text {
            font-size: 28px;
            color: #132F59;
            line-height: 40px;
            margin-bottom: 40px;
            font-weight: bold;
          }
          .label_info{
            display: flex;
            align-items: center;
            .info_box{
              margin-right: 38px;
              .info_num{
                display: flex;
                font-size: 28px;
                color: #132F59;
                line-height: 40px;
                font-weight: bold;
                .num_unit{
                  line-height: 20px;
                  font-size: 18px;
                  margin-left: 8px;
                }
              }
              .info_name{
                font-size: 18px;
                color: #BBC2D5;
                line-height: 25px;
              }
            }
          }
        }
      }
    }
    .applications_nav {
      height: 945px;
      padding: 100px 200px;
      .function_box {
        display: flex;
        align-items: baseline;
        margin-bottom: 100px;
        .label {
          font-size: 40px;
          font-weight: 800;
          color: #132F59;
          line-height: 55px;
          padding-left: 8px;
        }
        .en_label {
          font-size: 22px;
          color: #656973;
          line-height: 22px;
          padding: 8px 12px;
          font-weight: 200;
        }
      }
      .hotel_box {
        width: 100%;
        display: grid;
        justify-content: center;
        padding: 0 200px 52px;
        grid-gap: 82px;
        box-sizing: border-box;
        grid-template-columns: repeat(3, 1fr);
        .content_box {
          width: 452px;
          height: 589px;
          position: relative;
          .img_bg {
            position: absolute;
            width: 452px;
            height: 589px;
          }
          .text_box {
            position: relative;
            padding: 100px 0 100px 76px;
            display: flex;
            flex-direction: column;
            justify-content: center;
            .name {
              position: relative;
              font-size: 28px;
              font-weight: 500;
              color: #FFFFFF;
              line-height: 59px;
              text-align: center;
              width: 226px;
              border: 1px solid #FFFFFF;
              height: 59px;
              margin-bottom: 59px;
              margin-left: 37px;
            }
            .li {
              position: relative;
              font-size: 16px;
              font-weight: 100;
              color: #FFFFFF;
              line-height: 40px;
              max-width: 280px;
            }
          }
        }
      }
    }
  }
}
</style>
